import {
  Attribute,
  Component,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  OnChanges,
  OnInit,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { createMask } from '@ngneat/input-mask';

@Component({
  selector: 'app-input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class InputCurrencyComponent implements OnInit, OnChanges {
  @Input() className = '';
  @Input() id = '';
  @Input() amount = '';
  @Input() name = '';
  @Input() placeholder = '';
  @Input() required = false;
  @Input() min = '';
  @Input() max = '';
  @Input() disabled = false;
  @Input() icon = '';
  @Input() iconPlacement: 'prefix' | 'suffix' | '' = 'prefix';
  @Output() amountChange = new EventEmitter<number>();
  @Output() blur = new EventEmitter();

  value = '';
  currencyInputMask = createMask({
    alias: 'numeric',
    groupSeparator: ',',
    digits: 2,
    digitsOptional: false,
    prefix: '',
    placeholder: '0',
    numericInput: true,
    rightAlign: false,
    allowMinus: false,
  });

  constructor() {}

  /**
   * Set Inital value
   */
  ngOnInit(): void {
    this.value = this.amount;
  }

  /**
   * Set Input Currency value on amount change
   * @param changes @Input properties
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.amount) {
      this.value = changes.amount.currentValue;
    }
  }

  /**
   * Emit value to amount on Input currency value change
   * @param value string
   */
  onChange(value): void {
    this.value = value;
    this.amountChange.emit(this.toNumber(value));
  }

  /**
   *
   * @param value string
   * @returns number - Format 123,456.78 to 123456.78
   */
  toNumber(value): number {
    return +(value ?? '').split(',').join('') ?? 0;
  }

  /**
   * On Input Currency blur
   * @param event emit blur event
   */
  onBlur(event): void {
    this.blur.emit();
  }
}
